import Order from "./Order";
import BaseModel from "./BaseModel";
import Note from "./Note";

export default class OrderNote extends BaseModel {

	static entity = 'order_notes';
	static route = 'order-notes';
	static plural = 'order_notes';
	static singular = 'order_note';

	static fields () {
		return {
			id: this.attr(null), 
			order_id: this.attr(null),
			order: this.belongsTo(Order, 'order_id'),
			note_id: this.attr(null),
			note: this.belongsTo(Note, 'note_id'),
			drop: this.attr(null),
			created_at: this.attr(null), 
			updated_at: this.attr(null), 
			deleted_at: this.attr(null)
		}
	}

}
